import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Icon from "storybookComponents/Icon"
import Tab from "./tabs"
import { styles } from "./style";
import DialogContent from '@material-ui/core/DialogContent';



const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      {children}
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});





const ModalWithTabs = ({ classes, open, view, setView, handleCloseEventModal, copyTextToClipboard, data }) => {
  const [copied, setCopy] = React.useState();

  const renderView = (view, data) => {
    let line = view === 1 ? classes.dottedLine : classes.bgGrey;
    return (
      <div className={`${classes.viewStyle} ${line}`}>{data[view].url}</div>
    )
  }

  const handleClick = () => {
    setCopy(view);
    setTimeout(() => {
      setCopy(null);
    }, 2000)
    copyTextToClipboard(data[view].url)

  }

  return (
    <div>
      <Dialog onClose={handleCloseEventModal} scroll="paper" className={classes.dialogStyle} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle dividers onClose={handleCloseEventModal}>
          <Tab view={view} data={data} setView={setView} />
        </DialogTitle>
        <DialogContent className={classes.body}>
          {renderView(view, data)}
        </DialogContent>
        <div className={classes.actions}>
          <div className={copied === view ? classes.copiedButton : classes.buttonClass} onClick={handleClick}>
            {copied === view && <Icon className={classes.iconWeight} type="icon-check-single" size="xs" />}
            {copied === view ? "Copied" : "Copy"}
          </div>
        </div>
      </Dialog>
    </div>
  );
}


export default withStyles(styles)(ModalWithTabs);